import { AlgoliaProvider } from '@packages/services';

import { ABTestingProvider, AppStaticStateProvider, WishlistProvider } from '@packages/shared';
import React from 'react';
import { getUserData } from '@packages/shared';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

import dynamic from 'next/dynamic';
import { MainLayout } from '../../components/Layouts/MainLayout';
import { getAlgoliaClient, SharedProps } from '../../pageUtils';

const IS_E2E_TEST = getPublicRuntimeConfig('IS_E2E_TEST');

const SideEffectsProvider = dynamic(() => import('@packages/shared').then((mod) => mod.SideEffectsProvider));

export const SharedWrapper: React.FC<SharedProps> = (props) => {
  const { abTestConfig, cookies, deviceType, browser, productGridSlotConfig, url } = props;
  const userIdHash = getUserData(cookies).hash;

  return (
    <AppStaticStateProvider
      deviceType={deviceType}
      browser={browser}
      cookies={cookies}
      productGridSlotConfig={productGridSlotConfig}
      url={url}
      originalLocation={url}
    >
      <AlgoliaProvider algoliaClientByIndexName={getAlgoliaClient} deviceType={deviceType} userIdHash={userIdHash}>
        <ABTestingProvider abTestConfig={abTestConfig} e2eEnabled={IS_E2E_TEST}>
          <SideEffectsProvider>
            <WishlistProvider localStorageKey="mde_wishlist">
              <MainLayout>{props.children}</MainLayout>
            </WishlistProvider>
          </SideEffectsProvider>
        </ABTestingProvider>
      </AlgoliaProvider>
    </AppStaticStateProvider>
  );
};
